// extracted by css-extract-rspack-plugin
var _1 = "checkboxContainer__V7SwF";
export { _1 as "checkboxContainer" }
export default { "checkboxContainer": _1 }
